export default {
	namespaced: true,

	state: {
		isInitialized: {
			// courseCode: false
		},

		new: {
			isDummy: true,
			
			order: 1,

			title: 'Course Title',
			text: 'Course Description',
			
			isGroupCourse: false,
			isSequentialCourse: true,

			image: {
				url: 'DummyImage'
			},

			bigImage: {
				url: 'DummyImage'
			},

			modules: {
				new: {
					order:1,

					title: 'Module Title',
					text: 'Module Description',

					image: {
						url: 'DummyImage'
					},

					sections: {
						new: {
							order: 1,

							sectionTitle: 'Section',
							title: 'Section Title',
							text: 'Section Description',

							image: {
								url: 'DummyImage'
							},

							bigImage: {
								url: 'DummyImage'
							},

							video: {
								url: 'DummyVideo',

								loadingImage: 'DummyLoadingImage',
								readyImage: 'DummyReadyImage',

								autoPlay: false,
								controls: false,
								muted: false,
	
								progressLinearColor: 'primary',

								videoButton: {
									play: true,
									pause: true,
									replay: true,
									minus5Sec: true,
									minus10Sec: true,
									minus30Sec: true,
									plus5Sec: true,
									plus10sec: true,
									plus30Sec: true,
									halfSpeed: true,
									twiceSpeed: true,
									mute: true,
									unmute: true
								}
							},

							carousel: {
								'1': {
									image: {
										url: 'DummyImage',
										aspectRatio: 2/1
									},
									order: 1
								},
								'2': {
									image: {
										url: 'DummyImage',
										aspectRatio: 2/1
									},
									order: 2
								}
							},

							completeSection: 'Complete Section',

							openTest: {
								title: 'Open Test',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'dummy',
											pageType: 'trainingInput'
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
